import { generateSkinDefaults } from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

const buttonSkinParams: SkinDefinition = {
  'button-font': {
    type: 'FONT',
    state: 'regular',
  },
  'button-color': {
    type: 'CSS_COLOR',
    state: 'regular',
  },
  'button-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
  },
  'button-line-height': {
    type: 'SIZE',
    state: 'regular',
  },
  'button-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'regular',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'button-direction': {
    type: 'DIRECTION',
    state: 'regular',
  },
  'button-text-align': {
    type: 'TEXT_ALIGN',
    state: 'regular',
  },
  'button-text-highlight': {
    type: 'COLOR_ALPHA',
    state: 'regular',
  },
  'button-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'regular',
  },
  'button-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'regular',
  },
  'button-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'regular',
  },
  'button-hover-font': {
    type: 'FONT',
    state: 'hover',
  },
  'button-hover-color': {
    type: 'CSS_COLOR',
    state: 'hover',
  },
  'button-hover-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
  },
  'button-hover-line-height': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'hover',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'button-hover-direction': {
    type: 'DIRECTION',
    state: 'hover',
  },
  'button-hover-text-align': {
    type: 'TEXT_ALIGN',
    state: 'hover',
  },
  'button-hover-text-highlight': {
    type: 'COLOR_ALPHA',
    state: 'hover',
  },
  'button-hover-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'hover',
  },
  'button-hover-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'hover',
  },
  'button-hover-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'hover',
  },
  'button-disabled-font': {
    type: 'FONT',
    state: 'disabled',
  },
  'button-disabled-color': {
    type: 'CSS_COLOR',
    state: 'disabled',
  },
  'button-disabled-line-height': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-text-decoration': {
    type: 'TEXT_DECORATION_LINE',
    state: 'disabled',
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'button-disabled-direction': {
    type: 'DIRECTION',
    state: 'disabled',
  },
  'button-disabled-text-align': {
    type: 'TEXT_ALIGN',
    state: 'disabled',
  },
  'button-disabled-text-highlight': {
    type: 'COLOR_ALPHA',
    state: 'disabled',
  },
  'button-disabled-text-transform': {
    type: 'TEXT_TRANSFORM',
    state: 'disabled',
  },
  'button-disabled-text-outline': {
    type: 'TEXT_OUTLINE',
    state: 'disabled',
  },
  'button-disabled-text-shadow': {
    type: 'TEXT_SHADOW',
    state: 'disabled',
  },
  'button-background': {
    type: 'BACKGROUND_FILL',
    defaultValue: 'none',
    state: 'regular',
  },
  'button-box-shadow': {
    type: 'BOX_SHADOW',
    defaultValue: '0 0px 0px rgba(0, 0, 0, 0)',
    state: 'regular',
  },
  'button-border-left': {
    type: 'BORDER_SIDE',
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'button-border-right': {
    type: 'BORDER_SIDE',
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'button-border-top': {
    type: 'BORDER_SIDE',
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'button-border-bottom': {
    type: 'BORDER_SIDE',
    defaultValue: '0px none #000000',
    state: 'regular',
  },
  'button-padding-bottom': {
    type: 'SIZE',
    defaultValue: '0px',
    state: 'regular',
  },
  'button-padding-top': {
    type: 'SIZE',
    defaultValue: '0px',
    state: 'regular',
  },
  'button-padding-left': {
    type: 'SIZE',
    defaultValue: '0px',
    state: 'regular',
  },
  'button-padding-right': {
    type: 'SIZE',
    defaultValue: '0px',
    state: 'regular',
  },
  'button-border-top-left-radius': {
    type: 'SIZE',
    defaultValue: '0',
    state: 'regular',
  },
  'button-border-top-right-radius': {
    type: 'SIZE',
    defaultValue: '0',
    state: 'regular',
  },
  'button-border-bottom-left-radius': {
    type: 'SIZE',
    defaultValue: '0',
    state: 'regular',
  },
  'button-border-bottom-right-radius': {
    type: 'SIZE',
    defaultValue: '0',
    state: 'regular',
  },
  'button-hover-background': {
    type: 'BACKGROUND_FILL',
    state: 'hover',
  },
  'button-hover-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'hover',
  },
  'button-hover-border-left': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'button-hover-border-right': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'button-hover-border-top': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'button-hover-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'hover',
  },
  'button-hover-padding-bottom': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-padding-top': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-padding-left': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-padding-right': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-border-top-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-border-top-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-hover-border-bottom-right-radius': {
    type: 'SIZE',
    state: 'hover',
  },
  'button-disabled-background': {
    type: 'BACKGROUND_FILL',
    state: 'disabled',
  },
  'button-disabled-box-shadow': {
    type: 'BOX_SHADOW',
    state: 'disabled',
  },
  'button-disabled-border-left': {
    type: 'BORDER_SIDE',
    state: 'disabled',
  },
  'button-disabled-border-right': {
    type: 'BORDER_SIDE',
    state: 'disabled',
  },
  'button-disabled-border-top': {
    type: 'BORDER_SIDE',
    state: 'disabled',
  },
  'button-disabled-border-bottom': {
    type: 'BORDER_SIDE',
    state: 'disabled',
  },
  'button-disabled-letter-spacing': {
    type: 'SIZE',
    state: 'regular',
  },
  'button-disabled-padding-bottom': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-padding-top': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-padding-left': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-padding-right': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-border-top-left-radius': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-border-top-right-radius': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-border-bottom-left-radius': {
    type: 'SIZE',
    state: 'disabled',
  },
  'button-disabled-border-bottom-right-radius': {
    type: 'SIZE',
    state: 'disabled',
  },
};

export const collapsibleTextSkinDefinitionMap: Record<string, SkinDefinition> =
  {
    'wixui.skins.CollapsibleText': {
      font: {
        type: 'FONT',
        defaultValue: 'font_8',
        state: 'regular',
        paramName: 'font',
      },
      color: {
        type: 'CSS_COLOR',
        defaultValue: '#000000',
        state: 'regular',
        paramName: 'color',
      },
      'letter-spacing': {
        type: 'SIZE',
        defaultValue: '0em',
        state: 'regular',
        paramName: 'letter-spacing',
      },
      'line-height': {
        type: 'SIZE',
        defaultValue: 'unset',
        state: 'regular',
        paramName: 'line-height',
      },
      'text-decoration': {
        type: 'TEXT_DECORATION_LINE',
        defaultValue: 'none',
        state: 'regular',
        paramName: 'text-decoration',
      },
      // eslint-disable-next-line editor-elements/no-direction-in-skin-params
      direction: {
        type: 'DIRECTION',
        defaultValue: 'ltr',
        state: 'regular',
        paramName: 'direction',
      },
      'text-align': {
        type: 'TEXT_ALIGN',
        defaultValue: 'revert',
        state: 'regular',
        paramName: 'text-align',
      },
      'text-highlight': {
        type: 'COLOR_ALPHA',
        defaultValue: 'none',
        state: 'regular',
        paramName: 'text-highlight',
      },
      'text-transform': {
        type: 'TEXT_TRANSFORM',
        defaultValue: 'none',
        state: 'regular',
        paramName: 'text-transform',
      },
      'text-outline': {
        type: 'TEXT_OUTLINE',
        defaultValue:
          '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
        state: 'regular',
        paramName: 'text-outline',
      },
      'text-shadow': {
        type: 'TEXT_SHADOW',
        defaultValue: '0px 0px transparent',
        state: 'regular',
        paramName: 'text-shadow',
      },
      'text-font': {
        type: 'FONT',
        state: 'regular',
        paramName: 'text-font',
      },
      'text-color': {
        type: 'CSS_COLOR',
        state: 'regular',
        paramName: 'text-color',
      },
      'text-letter-spacing': {
        type: 'SIZE',
        state: 'regular',
        paramName: 'text-letter-spacing',
      },
      'text-line-height': {
        type: 'SIZE',
        state: 'regular',
        paramName: 'text-line-height',
      },
      'text-text-decoration': {
        type: 'TEXT_DECORATION_LINE',
        state: 'regular',
        paramName: 'text-text-decoration',
      },
      // eslint-disable-next-line editor-elements/no-direction-in-skin-params
      'text-direction': {
        type: 'DIRECTION',
        state: 'regular',
        paramName: 'text-direction',
      },
      'text-text-align': {
        type: 'TEXT_ALIGN',
        state: 'regular',
        paramName: 'text-text-align',
      },
      'text-text-highlight': {
        type: 'COLOR_ALPHA',
        state: 'regular',
        paramName: 'text-text-highlight',
      },
      'text-text-transform': {
        type: 'TEXT_TRANSFORM',
        state: 'regular',
        paramName: 'text-text-transform',
      },
      'text-text-outline': {
        type: 'TEXT_OUTLINE',
        state: 'regular',
        paramName: 'text-text-outline',
      },
      'text-text-shadow': {
        type: 'TEXT_SHADOW',
        state: 'regular',
        paramName: 'text-text-shadow',
      },
      ...buttonSkinParams,
    },
  };

export default generateSkinDefaults(collapsibleTextSkinDefinitionMap);
